import {inject, Injectable, NgZone, signal} from '@angular/core';
import {listen} from '@tauri-apps/api/event';
import {Router} from "@angular/router";
import {LocalStorageService} from "@customcoding/shared";

@Injectable({
	providedIn: 'root'
})
export class TauriService {
	isTauriApp: boolean;
	failedUploads = signal<any[]>([]);
	storageService = inject(LocalStorageService);

	constructor(private router: Router,private zone: NgZone) {
	}

	isDesktopApp(){

		if(typeof this.isTauriApp === 'undefined')
			this.isTauriApp = '__TAURI__' in window;
		return this.isTauriApp;
	}

	async initDesktopFeatures(){

		MoConsole.log("tauri listeners");
		const unlisten = await listen('tauri://menu', (event) => {
			MoConsole.log(`menu event fired: ${event.windowLabel}, payload: ${event.payload}`);
			if(event.payload == 'settings'){
				this.zone.run(() => {
					this.router.navigate(["/user/profile/personal-information"]);
				});
			}
		});


		//unlisten();

		/* for angular >= 17
		useEffect(() => {
			listen("menu-event", (e) => {
				MoConsole.log(e);
			});
		}, []);
		*/
	}

	/**
	 * Retrieves failed uploads from local storage and updates the signal
	 */
	getFailedUploads(): void {
		const failedUploadFiles = this.storageService.get('failedUploadFiles') ?? [];
		this.failedUploads.set(failedUploadFiles);
	}
}
